import CityPageTemplate from "../city-template/CityPageTemplate";
import { fortCollinsConfig } from "./data";

export default function FortCollinsPage() {
  return <CityPageTemplate config={fortCollinsConfig} />;
}